import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';

import useLoadPeriodos from '../../hooks/useLoadPeriodos';
import { isPeriodoInscricao } from '../../helper/ContextHelper';

import { useKeycloak } from '@react-keycloak/web'
import { handleLogin, handleLogout } from '../../security/keycloak';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';

import { MenuMirim, BannerHeader } from './Style';

import useStyles, { ButtonAppBarCollapse } from './Style';

import AuthorizedFunction from '../../security/AuthorizedFunction';
import { __ADMINISTRADOR, __CENTRAL, __DIGITADOR } from '../../security/RoleConfiguration';

const Header = props => {
    const classes = useStyles();

    const contexts = useLoadPeriodos();

    return (
        <div className={props.className}>
            <BannerHeader />

            <MenuMirim>
                <ButtonAppBarCollapse className={classes.menuColapsado}>
                    {isPeriodoInscricao(contexts) &&
                        <MenuItem>
                            <ButtonInscricao />
                        </MenuItem>
                    }
                    <MenuItem>
                        <ButtonQuemSomos />
                    </MenuItem>
                    <MenuItem>
                        <ButtonCalendario />
                    </MenuItem>
                    <MenuItem>
                        <ButtonRegulamento />
                    </MenuItem>
                    <MenuItem>
                        <ButtonFAQ />
                    </MenuItem>
                    <MenuItem>
                        <ButtonMaterialDidatico />
                    </MenuItem>                    
                    <MenuItem>
                        <ButtonAreaRestrita />
                    </MenuItem>
                </ButtonAppBarCollapse>

                <Grid
                    container
                    direction="row"
                    justify="space-evenly"
                    alignItems="center"
                    align="center"
                    className={classes.menuNormal}
                >
                    {isPeriodoInscricao(contexts) &&
                        <Grid item container xs={12} sm={2} lg={2} spacing={1} justify="center">
                            <ButtonInscricao />
                        </Grid>
                    }
                    <Grid item container xs={12} sm={2} lg={2} spacing={2} justify="center">
                        <ButtonQuemSomos />
                    </Grid>
                    <Grid item container xs={12} sm={1} lg={isPeriodoInscricao(contexts) ? 1 : 2} spacing={1} justify="center">
                        <ButtonCalendario />
                    </Grid>
                    <Grid item container xs={12} sm={1} lg={isPeriodoInscricao(contexts) ? 1 : 2} spacing={1} justify="center">
                        <ButtonRegulamento />
                    </Grid>
                    <Grid item container xs={12} sm={2} lg={2} spacing={1} justify="center">
                        <ButtonFAQ />
                    </Grid>
                    <Grid item container xs={12} sm={2} lg={2} spacing={1} justify="center">
                        <ButtonMaterialDidatico />
                    </Grid>
                    <Grid item container xs={12} sm={2} lg={2} spacing={1} justify="center">
                        <ButtonAreaRestrita />
                    </Grid>
                </Grid>
            </MenuMirim>
        </div>
    )
}

const ButtonAreaRestrita = () => {
    const classes = useStyles();
    const history = useHistory();

    const [keycloak,] = useKeycloak();
    const handleSubmitSignIn = () => handleLogin(`${process.env.REACT_APP_PUBLIC_URL}/admin/inicial`);
    const handleRestrictArea = () => history.push(`/admin/${AuthorizedFunction([ __ADMINISTRADOR, __CENTRAL ]) ? `inicial` : AuthorizedFunction([ __DIGITADOR ]) ? `digitacao` : `inicio`}`);

    return (
        <Button
            variant="contained"
            color="primary"
            className={clsx(classes.buttonMenu, classes.ligthBlue)}
            onClick={!keycloak.authenticated ? handleSubmitSignIn : handleRestrictArea}
        >
            ACESSO À ÁREA RESTRITA
        </Button>
    )
}

const ButtonRegulamento = () => {
    const classes = useStyles();

    const history = useHistory();
    const handleRegulamento = () => {
        history.push({ pathname: `/regulamento` });
    }

    return (
        <Button
            variant="contained"
            color="secondary"
            disableElevation
            className={classes.buttonMenu}
            onClick={handleRegulamento}
        >
            REGULAMENTO
        </Button>
    )
}

const ButtonFAQ = () => {
    const classes = useStyles();

    const history = useHistory();
    const handleFAQ = () => {
        history.push({ pathname: `/faq` });
    }

    return (
        <Button
            variant="contained"
            color="secondary"
            disableElevation
            className={classes.buttonMenu}
            onClick={handleFAQ}
        >
            PERGUNTAS FREQUENTES
        </Button>
    )
}

const ButtonQuemSomos = () => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <Button 
                onClick={handleMenu}
                variant="contained"
                color="secondary"
                disableElevation
                className={classes.buttonMenu}
            >
                QUEM SOMOS
            </Button>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                onClose={handleClose}
            >
                <MenuItem>
                    <ButtonApresentacao />
                </MenuItem>
                <MenuItem>
                    <ButtonContato />
                </MenuItem>
                <MenuItem>
                    <ButtonPrivacidade />
                </MenuItem>
            </Menu>
        </>
    );
}

const ButtonApresentacao = () => {
    const classes = useStyles();

    const history = useHistory();
    const handleApresentacao = () => {
        history.push({ pathname: `/apresentacao` });
    }

    return (
        <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.buttonMenu}
            onClick={handleApresentacao}
        >
            APRESENTAÇÃO
        </Button>
    )
}

const ButtonContato = () => {
    const classes = useStyles();

    const history = useHistory();
    const handleContato = () => {
        history.push({ pathname: `/contato` });
    }

    return (
        <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.buttonMenu}
            onClick={handleContato}
        >
            CONTATO
        </Button>
    )
}

const ButtonPrivacidade = () => {
    const classes = useStyles();

    const history = useHistory();
    const handlePrivacidade = () => {
        history.push({ pathname: `/privacidade` });
    }

    return (
        <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.buttonMenu}
            onClick={handlePrivacidade}
        >
            AVISO DE PRIVACIDADE
        </Button>
    )
}


const ButtonMaterialDidatico = () => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <Button 
                onClick={handleMenu}
                variant="contained"
                color="secondary"
                disableElevation
                className={classes.buttonMenu}
            >
                MATERIAL DIDÁTICO
            </Button>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                onClose={handleClose}
            >
                <MenuItem>
                    <ButtonProvasSolucoes />
                </MenuItem>
                <MenuItem>
                    <ButtonQuebraCabecaMatematica />
                </MenuItem>
            </Menu>
        </>
    );
}

const ButtonProvasSolucoes = () => {
    const classes = useStyles();

    const history = useHistory();
    const handleProvasSolucoes = () => {
        history.push({ pathname: `/provas-solucoes` });
    }

    return (
        <Button
            variant="contained"
            color="primary"
            className={classes.buttonMenu}
            onClick={handleProvasSolucoes}
        >
            PROVAS E SOLUÇÕES ANTERIORES
        </Button>
    )
}

const ButtonQuebraCabecaMatematica = () => {
    const classes = useStyles();

    const handleQuebraCabecaMatematica = () => {
        window.open("https://portaldaobmep.impa.br/index.php/site/index?a=4", "_blank");
    }

    return (
        <Button
            variant="contained"
            color="primary"
            className={classes.buttonMenu}
            onClick={handleQuebraCabecaMatematica}
        >
            QUEBRA CABEÇAS DE MATEMÁTICA
        </Button>
    )
}

const ButtonCalendario = () => {
    const classes = useStyles();

    const history = useHistory();
    const handleCalendario = () => {
        history.push({ pathname: `/calendario` });
    }

    return (
        <Button
            variant="contained"
            color="secondary"
            disableElevation            
            className={classes.buttonMenu}
            onClick={handleCalendario}
        >
            CALENDÁRIO
        </Button>
    )
}

const ButtonInscricao = () => {
    const classes = useStyles();

    const history = useHistory();
    const [keycloak,] = useKeycloak();
    
    const handleFormularioInscricao = () => {
        if (keycloak.authenticated)
            handleLogout(`${process.env.REACT_APP_PUBLIC_URL}/inscricao`);
        
        history.push({ pathname: `/inscricao` });
    }

    return (
        <Button
            variant="contained"
            color="primary"
            className={clsx(classes.buttonMenu, classes.ligthBlue)}
            onClick={handleFormularioInscricao}
        >
            PROFESSOR, CLIQUE AQUI E SE INSCREVA
        </Button>
    )
}

export default Header;
